import { useCallback, useMemo, useState } from 'react';

export const useItem = props => {
  const { product, select_options, configurableThumbnailSource, configurable_options, uid, handleRemoveItem, item } =
    props;

  const [isDeleting, setIsDeleting] = useState(false);
  const [customOptions, setCustomOptions] = useState(false);

  const removeItem = () => {
    setIsDeleting(true);
    handleRemoveItem(uid);
  };

  const handleShowCustomOptions = useCallback(() => {
    setCustomOptions(!customOptions);
  }, [customOptions]);

  const customizable_options_data = useMemo(() => {
    if (!product) {
      return [];
    }

    const temp = [];

    if (product.ampProtOption?.items?.length) {
      product.ampProtOption?.items?.map(item => {
        item.values.map(value => {
          select_options?.map(selectedItem => {
            if (value.option_id == selectedItem?.option_id && value.value_index == selectedItem?.option_value_id) {
              temp.push({
                option_label: item.label,
                value_label: value.label,
              });
            }
          });
        });
      });
    } else if (configurable_options && configurable_options.length) {
      configurable_options.map(item => {
        temp.push({
          option_label: item.option_label,
          value_label: item.value_label,
        });
      });
    }

    return temp;
  }, [configurable_options, product, select_options]);

  const imageSource = item.select_product_image;

  return {
    customizable_options_data,
    imageSource,
    isDeleting,
    removeItem,
    customOptions,
    handleShowCustomOptions,
  };
};
